import React from "react";
import { TERMS_VERSION } from "../../common/constants";

const ShippingPolicy = () => {
  return (
    <div
      style={{
        backgroundColor: "#f5f7fb",
        minHeight: "100vh",
        padding: "60px 20px",
      }}
    >
      <div
        style={{
          maxWidth: "900px",
          margin: "0 auto",
          backgroundColor: "#ffffff",
          padding: "40px",
          borderRadius: "12px",
          boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
          lineHeight: "1.8",
          color: "#333",
        }}
      >
        {/* Header */}
        <h1
          style={{
            marginBottom: "10px",
            fontSize: "2.2rem",
            fontWeight: "700",
            color: "#111",
          }}
        >
          Shipping & Delivery Policy
        </h1>

        <p style={{ color: "#666", marginBottom: "30px" }}>
          Speak Bold with KK • Version {TERMS_VERSION}
        </p>

        <p>
          Speak Bold with KK provides <strong>digital-only</strong> services.
          We do not sell or ship any physical products.
        </p>

        {/* Section 1 */}
        <h2 style={sectionTitleStyle}>Digital Service Delivery</h2>
        <ul style={listStyle}>
          <li>
            After successful payment, users receive access to purchased sessions
            or digital learning content.
          </li>
          <li>
            Session booking confirmations and updates are delivered via email
            and/or in-app notifications.
          </li>
          <li>
            Access credentials and purchased session credits are reflected
            directly within the user account.
          </li>
        </ul>

        {/* Section 2 */}
        <h2 style={sectionTitleStyle}>Delivery Timeframe</h2>
        <p>
          Access to digital services is typically granted immediately after
          successful payment confirmation. In rare cases involving technical
          delays, access may take a short time to reflect in your account.
        </p>

        {/* Section 3 */}
        <h2 style={sectionTitleStyle}>No Physical Shipping</h2>
        <p>
          Since Speak Bold with KK operates exclusively online, no physical
          materials are shipped. All services are delivered digitally through
          the website or mobile application.
        </p>

        {/* Section 4 */}
        <h2 style={sectionTitleStyle}>Support</h2>
        <p>
          If you experience any issues accessing your purchased sessions or
          digital content, please contact us at:
        </p>

        <div
          style={{
            backgroundColor: "#f9fafc",
            padding: "20px",
            borderRadius: "8px",
            marginTop: "15px",
          }}
        >
          <p style={{ margin: "5px 0" }}>
            <strong>Email:</strong> support@speakboldwithkk.com
          </p>
        </div>

        {/* Footer */}
        <div
          style={{
            marginTop: "40px",
            paddingTop: "20px",
            borderTop: "1px solid #eee",
            fontSize: "0.9rem",
            color: "#888",
          }}
        >
          Last Updated: {new Date().getFullYear()} <br />
          © {new Date().getFullYear()} Speak Bold with KK. All rights reserved.
        </div>
      </div>
    </div>
  );
};

const sectionTitleStyle = {
  marginTop: "35px",
  fontSize: "1.4rem",
  fontWeight: "600",
  color: "#222",
};

const listStyle = {
  paddingLeft: "20px",
  marginTop: "10px",
};

export default ShippingPolicy;
